module.exports = __webpack_public_path__ + "assets/img/102004.c4238870.svg";